<ng-container *ngIf="priceListsFromStore$ | async as priceLists">
  <lx-price-lists-portal-price-list-panel
    [priceListFilters]="priceListsFiltersFromStore$ | async"
    [withData]="priceLists?.length > 0"
    (filtersChanged)="filterSchools($event)"
  >
    <div *ngIf="filteredPriceLists$ | async as priceLists">
      <lx-price-lists-portal-price-lists-data [priceLists]="priceLists" [company]="company" [applicationForms]="applicationForms">
      </lx-price-lists-portal-price-lists-data>
    </div>
  </lx-price-lists-portal-price-list-panel>
</ng-container>
